import { Colors } from '@sweatpals/react-ui-kit';

export const checkoutModalNavBarStyles = () => ({
	container: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	logo: {
		cursor: 'default',
		height: '21px',
	},
	rightSection: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: '16px',
	},
	userProfileContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '5px',
		borderRadius: '250px',
		backgroundColor: Colors.white_a10,
		padding: '2px 8px 2px 4px',
		cursor: 'pointer',
	},
	userAvatar: {
		width: '32px',
		height: '32px',
	},
	userName: {
		color: 'white',
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: '500',
		lineHeight: '120%',
	},
	closeButton: {
		color: '#FFFFFF',
		border: '1px solid #FFFFFF66',
		width: '48px',
		height: '48px',
	},
	mobileDrawer: {
		'& .MuiPaper-root': {
			backgroundColor: Colors.grey_101010,
			borderRadius: '16px 16px 0px 0px',
			padding: '8px 20px 28px',
		},
		'& .MuiBackdrop-root': {
			backgroundColor: 'rgba(19, 19, 19, 0.50)',
			backdropFilter: 'blur(12px)',
		},
		zIndex: 1400,
		backgroundColor: 'none',
	},
	drawerHandle: {
		width: '20px',
		height: '3px',
		margin: '0px auto',
		marginTop: '8px',
		background: 'white',
		borderRadius: '26px',
	},
	mobileMenuItem: {
		p: 0,
	},
});
